import actionTypes from '../constants/action-types';

const redo = () => ({
  type: actionTypes.REDO,
});

export default redo;
